<template>
	<component :is="layout">
		<router-view />
	</component>
</template>

<script>
const default_layout = "default";
export default {
	computed: {
		layout() {
			return (this.$route.meta.layout || default_layout) + '-layout';
		}
	},
	created() {
    	this.initial();
  	},
  	methods: {
    	initial() {
      		this.$store.dispatch("user/getUserData");
      		this.$store.dispatch("reference/getCountries");
      		this.$store.dispatch("reference/getOffices");
    	}
  	}
};
</script>